import SelectInsurance from './select-insurance';

export default SelectInsurance;
